<template>
	<h2 class="headLine">お気に入り一覧</h2>
	<p v-text="message"></p>
	<div>
		<ul id="infinityScroll" class="thumbList">
			<li v-for="item in favorites" v-if="item !== null">
				<my-favoriteaction v-bind:id="item.id" v-bind:label="false" v-bind:action="false"></my-favoriteaction>
				<a v-link="{path: '/detail/' + item.id}">
					<div class="thumbList__thumb">
						<!-- <div v-my-preloadimg="{src: item.thumbnail, class: ['img-responsive', 'loadingEfect']}">
							<my-loading></my-loading>
						</div> -->
						<img v-bind:src="item.thumbnail" class="img-responsive" alt="">
					</div>
					<div class="thumbList__icons">
						<template v-for="item2 in item.icons">
							<span v-bind:class="item2.icon" class="tooltip1 humbList__icon" title="{{item2.title}}"><span>{{item2.title}}</span></span>
						</template>
					</div>
					<p v-text="getPrefectures(item.address_id)" class="thumbList__area"></p>
					<p v-text="item.name" class="thumbList__name"></p>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { getPrefecturesList } from '../vuex/getters';
module.exports = {
	route: {
		data: function(){
			// get favorites
			this.getFavorites();

			this.$nextTick(function () {
				// ページ遷移後、頭に移動
				this.smoothScroll('body');
			});
		}
	},
	vuex: {
		getters: {
			prefecturesList: getPrefecturesList
		}
	},
	data: function () {
		return {
			pageMeta: this.$route.pageMeta,
			favorites: [],
			removeCandidate: [],
			message: ''
		};
	},
	created: function(){
		// seta meta
		var metaObj = {
			title: 'お気に入り一覧' + ' | ' + this.pageMeta.title_short,
			keywords: this.pageMeta.keywords,
			description: this.pageMeta.description,
			url: this.pageMeta.url,
			image: this.pageMeta.image
		};

		this.setMeta(metaObj);
	},
	ready: function(){
		// console.log('favorites ready');

		// ga
		// var trackingUrl = window.location.hash.replace(/^#!/, '');
		// window.ga('create', 'UA-4877520-11', 'auto');
		// window.ga('set', {
		// 	page: trackingUrl,
		// 	title: 'お気に入り一覧' + ' | ' + this.pageMeta.title_short
		// });
		// window.ga('send', 'pageview');
	},
	beforeDestroy: function () {
		this.refreshFavorites();
		// this.removeFavoritesExec();
	},
	methods: {
		debug: function(){
			console.log(this.results);
		},
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(profile_id){
			var devmode = this.devMode();
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var apipath = host + '//' + hostname + '/s/api/';
			var url = devmode ? '/static/json/sample_detail.json' : apipath + 'profile/' + profile_id;
			return url;
		},
		getJson: function(url, index = ''){
			var devmode = this.devMode();
			this.$http.get(url).then(function (response) {
				// success callback
				var json = response.data;
				// console.log(json.Profiles.img_1);
				var dataObj = null;

				if (json.length !== 0 && Object.keys(json).length !== 0){
					var thumbFileName = '';
					if (json.Profiles['img_1']){
						var imgDir = devmode ? '/static/images/sample_studio/' : '/s/img/studio/';
						thumbFileName = imgDir + json.Profiles.img_1.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
					} else {
						thumbFileName = '/static/images/thumb/no_image_r.jpg';
					}

					dataObj = {
						id: json.Profiles.id,
						name: json.Profiles.name,
						promoword: json.Profiles.promoword,
						thumbnail: thumbFileName,
						address_id: json.Profiles.address_id,
						fav: true
					};
				}

				if (index !== ''){
					this.favorites.$set(index, dataObj);
				} else {
					this.favorites.unshift(dataObj);
				}
			}, function (response) {
				// error callback
				console.log(response.status);
				console.log('データの取得に失敗しました');
			});
		},
		getFavorites: function(){
			var cr_v = String(window.localStorage.getItem('fav'));
			var favArr = cr_v.split('%2C');
			favArr = favArr.filter(function(e){
				return e !== '';
			});
			favArr.reverse();
			// console.log(favArr);
			for (var i = 0; i < favArr.length; i++){
				var url = this.createJsonPath(favArr[i]);
				this.getJson(url, i);
			}
		},
		// removeFavorites: function(index){
		// 	var self = this.favorites[index];
		// 	// var rc = this.removeCandidate;
		//
		// 	var my_id = encodeURIComponent(',' + self.id);
		// 	var match_my_id = new RegExp(my_id, 'g');
		// 	var cr_v = String(window.localStorage.getItem('fav'));
		//
		// 	if (cr_v.match(match_my_id) !== null){
		// 		// matching, remove favorite action
		// 		self.fav = false;
		// 		var remove_v = cr_v.replace(match_my_id, '');
		// 		window.localStorage.setItem('fav', remove_v);
		// 	} else {
		// 		// no matching, add favorite action
		// 		self.fav = true;
		// 		var add_v = cr_v + my_id;
		// 		// var add_v = my_id + cr_v;
		// 		window.localStorage.setItem('fav', add_v);
		// 	}
		//
		// 	// if (self.fav){
		// 	// 	// 削除候補に追加
		// 	// 	rc.push(self.id);
		// 	// 	self.fav = false;
		// 	// } else {
		// 	// 	// 削除候補から除外
		// 	// 	for (var i = 0; i < rc.length; i++){
		// 	// 		if (rc[i] === self.id){
		// 	// 			rc.splice(i, 1);
		// 	// 		}
		// 	// 	}
		// 	// 	self.fav = true;
		// 	// }
		// 	// console.log(rc);
		// },
		// removeFavoritesExec: function(){
		// 	// お気に入り削除の実行
		// 	var rc = this.removeCandidate;
		//
		// 	if (rc.length !== 0){
		// 		for (var i = 0; i < rc.length; i++){
		// 			var my_id = encodeURIComponent(',' + rc[i]);
		// 			var match_my_id = new RegExp(my_id, 'g');
		// 			var cr_v = String(window.localStorage.getItem('fav'));
		//
		// 			if (cr_v.match(match_my_id) !== null){
		// 				this.fav = false;
		// 				var remove_v = cr_v.replace(match_my_id, '');
		// 				window.localStorage.setItem('fav', remove_v);
		// 			}
		//
		// 			this.$dispatch('deliverFavAction', rc[i]);
		// 		}
		// 	}
		// },
		refreshFavorites: function(){
			this.$dispatch('deliverRefreshFavorites');
		}
	},
	components: {
		'my-favoriteaction': require('./favorite_action.vue')
	},
	mixins: [
		require('../mixins/setMeta.js'),
		require('../mixins/addIconsConf.js'),
		require('../mixins/getPrefectures.js'),
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
.debugConsole{
	background-color: rgba(0,0,0,.8);
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 100;
	padding: 10px;
}
.debug{
	color: white;
}
</style>



// WEBPACK FOOTER //
// favorites.vue?4b27b037